import "../site/all.scss";
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import debounce from "lodash.debounce";
import onLoad from "./common/onLoad";
//import removeOrphanPipe from "components/inline-list/remove-orphan-pipe";

/** Alpine **/
// register collapse plugin
Alpine.plugin(collapse);

// when alpine is ready, init mainNavItem component
document.addEventListener("alpine:init", () => {
  Alpine.data("mainNavItem", () => ({
    open: false,
    toggle() {
      if (this.open) {
        return this.close();
      }
      this.$refs.panel.style.zIndex = 2;
      this.$refs.button.focus();
      this.open = true;
    },
    close(focusAfter) {
      if (!this.open) return;
      this.$refs.panel.style.zIndex = 1;
      this.open = false;
      focusAfter && focusAfter.focus();
    },
  }));
});
// start() must come after the eventListener
// (see https://alpinejs.dev/essentials/installation)
Alpine.start();

window.addEventListener("load", (event) => {
  onLoad();

  // Remove any orphan pipes from .inlineList--pipe
  // Has bugs and might not be wanted cross-site
  //removeOrphanPipe();

  //adds Comboxbox vue custom component to DOM
  /*
  // this works, but opting instead to us SSR in the publications.twig template
  //@todo: generalize this to work for any vue component in designsystem
  document.querySelectorAll("Dropdown").forEach((el) => {
    import(`components/dropdown/Dropdown.vue`).then((module) => {
      //loop through attributes and add event handlers
      const handlers = [];
      for (const attribute of el.attributes) {
        if (attribute.name.startsWith("on-")) {
          handlers[kebabToCamel(attribute.name)] = eval(attribute.value);
        }
      }
      createApp(module.default, {
        ...JSON.parse(el.dataset.context),
        ...handlers, // event listeners
      }).mount(el);
    });
  });
  */
});

// Observe .l-master__main for DOM mutations, and retrigger our onLoad methods on any newly added nodes
const mainChildListObserver = new MutationObserver((mutationList, observer) => {
  debounceOnLoad();
});
const debounceOnLoad = debounce(function () {
  console.log("**** Debounced ****");
  onLoad();
}, 1500);

// Start observing the target node for configured mutations
mainChildListObserver.observe(document.querySelector(".l-master__main"), {
  childList: true,
  subtree: true,
});

function kebabToCamel(str) {
  return str
    .split("-")
    .map((e, i) => {
      return i === 0 ? e : e[0].toUpperCase() + e.slice(1);
    })
    .join("");
}
